module.exports = __webpack_public_path__ + "static/media/plus_red.cb6ff4cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/plus_red.svg
// module id = 376
// module chunks = 0